package com.essntl.features.tag.ui.alltags

import com.essntl.features.tag.domain.model.TagModel

sealed interface AllTagsEvent {
    data object GetAllTags : AllTagsEvent
    data class AddTag(val t: TagModel) : AllTagsEvent
    data class EditTag(val t: TagModel) : AllTagsEvent
    data class DeleteTag(val t: TagModel) : AllTagsEvent
}